module.exports = __webpack_public_path__ + "img/597.1fea1e6d.png";